export const hasMultilineAddress = (form) => {
    return form?.fields?.some((field) => field.view?.fieldType === 'MULTILINE_ADDRESS' ||
        field.view?.fieldType === 'ECOM_ADDRESS');
};
//# sourceMappingURL=has-multiline-address.js.map